




























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";


@Component({
      name      : "ValidatableInputField",
      components: {
      }
  })
  export default class ValidatableInputField extends Vue {
      @Prop({
          type: String
      })
      public readonly label!: string;
      @Prop({
          type: String
      })
      public readonly vid!: string;
      @Prop({
          type: String
      })
      public readonly name!: string;
      @PropSync("value", {type: String})
      public syncedValue!: string;
      @Prop({
          type: String
      })
      public readonly rules!: string;
      @Prop({
          type: String
      })
      public readonly type!: string;
      @Prop({
          type: String
      })
      public readonly icon!: string;
      @Prop({
          default: false,
          type   : Boolean
      })
      public readonly lazy!: boolean;
      @Prop({
          default: false,
          type   : Boolean
      })
      public readonly enableProgress!: boolean;


      modeSelector(): { on: (string)[] } {
          const mode = this.lazy ? "blur" : "input";
          return {on: [mode]};
      }
  }
